module.exports = __webpack_public_path__ + "img/29.85cbbb9a.png";